import SafeArea from './safe-area';
import './styles/index.scss';
export default SafeArea;
